module.exports = __webpack_public_path__ + "static/img/1.39a96f4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/12/1.png
// module id = 8ZKw
// module chunks = 0